import { createFeatureSelector, createSelector } from '@ngrx/store';
import { LatestDeviceDiagnosticDto } from '@rocksoft/appmanagement-sdk';
import * as fromReducer from './latest-device-diagnostics.reducer';
import { LatestDeviceDiagnosticsState } from './latest-device-diagnostics.state';

export const selectLatestDeviceDiagnosticsState = createFeatureSelector<LatestDeviceDiagnosticsState>(
  fromReducer.latestDeviceDiagnosticsFeatureKey
);

export const selectAllLatestDeviceDiagnostics = createSelector(
  selectLatestDeviceDiagnosticsState,
  fromReducer.selectAllLatestDeviceDiagnostics
);

export const selectLatestDeviceDiagnosticIds = createSelector(
  selectLatestDeviceDiagnosticsState,
  fromReducer.selectLatestDeviceDiagnosticIds
);

export const selectLatestDeviceDiagnosticEntities = createSelector(
  selectLatestDeviceDiagnosticsState,
  fromReducer.selectLatestDeviceDiagnosticEntities
);

export const selectLatestDeviceDiagnosticByUdid = (udid: string) =>
  createSelector(selectLatestDeviceDiagnosticsState, (state) => state.entities[udid]);

export const selectLatestDeviceDiagnosticsForUdids = (udids: string[]) =>
  createSelector(selectLatestDeviceDiagnosticsState, (state): LatestDeviceDiagnosticDto[] =>
    udids.flatMap((udid) => {
      const diagnostic = state.entities[udid];
      return diagnostic ? [diagnostic] : [];
    })
  );
